






































import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'IconListView',
  props: {
    width: {
      type: String,
      default: '24',
    },
    height: {
      type: String,
      default: '24',
    },
  },
});
